import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ArrowRight } from 'lucide-react'
import { Link as RouterLink } from 'react-router-dom'
import { Button } from '@oasisprotocol/ui-library/src/components/ui/button'
import { useConsensusFreshness } from 'app/components/OfflineBanner/hook'
import { useGetConsensusValidators, useGetStatus } from 'oasis-nexus/api'
import { EcosystemCard } from './EcosystemCard'
import consensusBg from './images/consensus-bg.svg'
import { fixedNetwork, RouteUtils } from '../../utils/route-utils'
import { Network } from '../../../types/network'

const network: Network = fixedNetwork ?? 'mainnet'

export const ConsensusCard: FC = () => {
  const { t } = useTranslation()
  const consensusStatusQuery = useGetStatus(network)
  const { outOfDate: consensusOutOfDate } = useConsensusFreshness(network)
  const validatorsQuery = useGetConsensusValidators(network, { limit: 1000 })
  const activeValidatorsCount = validatorsQuery.data?.data.validators.filter(v => v.in_validator_set).length

  return (
    <EcosystemCard
      isLoading={consensusStatusQuery.isLoading || validatorsQuery.isLoading}
      description={t('home.ecosystem.consensus')}
      title={t('common.consensus')}
      background={consensusBg}
      layer="consensus"
      network={network}
      outOfDate={consensusOutOfDate}
      latestBlock={consensusStatusQuery?.data?.data?.latest_block}
      activeNodes={activeValidatorsCount}
      footer={
        <div className="flex w-full gap-4">
          <Button variant="outline" size="lg" className="flex-1" asChild>
            <RouterLink to={RouteUtils.getDashboardRoute({ network, layer: 'consensus' })}>
              {t('common.testnet')}
            </RouterLink>
          </Button>
          <Button size="lg" className="flex-1" asChild>
            <RouterLink to={RouteUtils.getDashboardRoute({ network, layer: 'consensus' })}>
              {t('common.mainnet')}
              <ArrowRight />
            </RouterLink>
          </Button>
        </div>
      }
    />
  )
}

export const ConsensusFallbackCard: FC = () => {
  const { t } = useTranslation()

  return (
    <EcosystemCard
      description={t('home.ecosystem.consensus')}
      title={t('common.consensus')}
      background={consensusBg}
      layer="consensus"
      network={network}
    />
  )
}
